import SessionPlugin from './lib/SessionPlugin'
import systemMode from './lib/modules/systemMode'
import systemPrivileges from './lib/modules/systemPrivileges'
import sessionMixin from './lib/sessionMixin'
import privilegeMixin from './lib/mixins/privilegeMixin'

export default SessionPlugin
export {
  sessionMixin,
  privilegeMixin,
  systemMode,
  systemPrivileges
}
